// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.measure-result {
    margin-top: 0.25em;
}

input.measure-result-field {
    flex: 1 1 auto;
    text-align: center;
    field-sizing: content;
}

span.measure-unit-label {
    padding: 0.25em;
    height: 2em;
    background-color: var(--input-bg-color);
    border: 1px solid var(--border-color);
    border-right-width: 0;
    display: flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./plugins/style/Measure.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,uCAAuC;IACvC,qCAAqC;IACrC,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["div.measure-result {\n    margin-top: 0.25em;\n}\n\ninput.measure-result-field {\n    flex: 1 1 auto;\n    text-align: center;\n    field-sizing: content;\n}\n\nspan.measure-unit-label {\n    padding: 0.25em;\n    height: 2em;\n    background-color: var(--input-bg-color);\n    border: 1px solid var(--border-color);\n    border-right-width: 0;\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
